<template>
    <div class="bulk-action-bar teal-dark py-2 px-8">
        <div class="totals">
            <slot name="bulkActionBarPrepend"></slot>
        </div>
        <div v-for="(action, index) in bulkActions"
            :key="`action_${index}`"
            class="action mr-8"
            :class="{ 'disabled-action': !action.disabledRule }"
        >
            <font-awesome-icon
                v-if="action.disabledRule"
                class="action-icon white--text mr-3"
                :icon="`${action.faIconStyle} fa-${action.faIcon}`"
                size="lg"
            ></font-awesome-icon>
            <div
                v-else
                v-tooltip="{
                    content: action.disabledMsg,
                    delay: { show: 500, hide: 0 },
                }"
            >
                <font-awesome-icon
                    class="action-icon-disabled white--text mr-2"
                    :icon="`fas fa-triangle-exclamation`"
                    size="lg"
                ></font-awesome-icon>
            </div>
            <p class="link white--text" :class="{ 'disabled': !action.disabledRule }" @click="emitAction(action)">{{ action.itemText }}</p>
        </div>
    </div>
</template>

<script setup>
import { defineEmits } from 'vue';
let emit = defineEmits(['bulk-action']);  

const props = defineProps({
    bulkActions: {
        type: Array,
        default: () => [],
    }
});

const emitAction = (action) => {
    emit('bulk-action', action)
}

</script>

<style lang="scss" scoped>
.bulk-action-bar {
    width: 100%;
    display: flex;

    .totals {
        display: flex;
        align-items: center;
    }

    .action {
        display: flex;
        align-items: center;
        cursor: pointer;

        &.disabled-action {
            cursor: initial;
        }

        .action-icon {
            transition: all 0.2s ease-in-out;
        }
        .link {
            &.disabled {
                cursor: initial;
            }
        }

        &:hover {
            .link, .action-icon {
                color: $grey04;

                &.disabled {
                    pointer-events: none;
                    color: white;
                }
            }

            .action-icon-disabled {
                color: white;
                cursor: pointer;
            }
        }

        .link {
            cursor: pointer;
        }
    }
}

.slide-down-enter-active {
    transition: all 0.3s ease-out;
}

.slide-down-leave-active {
    transition: all 0.2s ease-in;
}

.slide-down-enter-from,
.slide-down-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}
</style>
